import axios from "axios";

const getBackendUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
  }
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && !envUrl.includes("localhost") && !envUrl.includes("127.0.0.1")) {
    return envUrl;
  }
  // Production Backend URL Fallback
  // Replace this with your Google Cloud VM domain (e.g., "https://api.renessai.in") if you don't build with REACT_APP_BACKEND_URL
  return "https://api.renessai.in";
};

const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token from localStorage when present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("reness_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const createConsultation = (payload) =>
  api.post("/consultations", payload).then((r) => r.data);
export const fetchProducts = () => api.get("/products").then((r) => r.data);
export const fetchPricing = () => api.get("/pricing").then((r) => r.data);
export const fetchCourses = () => api.get("/courses").then((r) => r.data);
export const fetchSiteSettings = () => api.get("/site/settings").then((r) => r.data);
export const fetchSiteTabs = () => api.get("/site/tabs").then((r) => r.data);

// Auth
export const login = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const logout = () => api.post("/auth/logout").then((r) => r.data);
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);

// Admin
export const adminApi = {
  stats: () => api.get("/admin/stats").then((r) => r.data),
  // settings
  getSettings: () => api.get("/admin/settings").then((r) => r.data),
  updateSettings: (data) => api.put("/admin/settings", data).then((r) => r.data),
  // tabs
  listTabs: () => api.get("/admin/tabs").then((r) => r.data),
  createTab: (data) => api.post("/admin/tabs", data).then((r) => r.data),
  updateTab: (id, data) => api.put(`/admin/tabs/${id}`, data).then((r) => r.data),
  deleteTab: (id) => api.delete(`/admin/tabs/${id}`).then((r) => r.data),
  // products
  listProducts: () => api.get("/admin/products").then((r) => r.data),
  createProduct: (data) => api.post("/admin/products", data).then((r) => r.data),
  updateProduct: (id, data) => api.put(`/admin/products/${id}`, data).then((r) => r.data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`).then((r) => r.data),
  // pricing
  listPricing: () => api.get("/admin/pricing").then((r) => r.data),
  createPricing: (data) => api.post("/admin/pricing", data).then((r) => r.data),
  updatePricing: (id, data) => api.put(`/admin/pricing/${id}`, data).then((r) => r.data),
  deletePricing: (id) => api.delete(`/admin/pricing/${id}`).then((r) => r.data),
  // courses
  listCourses: () => api.get("/admin/courses").then((r) => r.data),
  createCourse: (data) => api.post("/admin/courses", data).then((r) => r.data),
  updateCourse: (id, data) => api.put(`/admin/courses/${id}`, data).then((r) => r.data),
  deleteCourse: (id) => api.delete(`/admin/courses/${id}`).then((r) => r.data),
  // media
  listMedia: () => api.get("/admin/media").then((r) => r.data),
  uploadMedia: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api
      .post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
  deleteMedia: (id) => api.delete(`/admin/media/${id}`).then((r) => r.data),
  // leads
  listLeads: (q = "") => api.get(`/admin/leads`, { params: { q } }).then((r) => r.data),
  deleteLead: (id) => api.delete(`/admin/leads/${id}`).then((r) => r.data),
  listConsultations: (q = "") =>
    api.get(`/admin/consultations`, { params: { q } }).then((r) => r.data),
  deleteConsultation: (id) => api.delete(`/admin/consultations/${id}`).then((r) => r.data),
  listAgentTurns: () => api.get("/admin/agent-turns").then((r) => r.data),
};

export const formatApiError = (err, fallback = "Something went wrong.") => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return JSON.stringify(d);
};

export const mediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/uploads/")) {
    return `${BACKEND_URL}${url}`;
  }
  return url;
};
